import React from "react";
import { cn } from "utils";
import { VirtualList } from "@ospweb/sdk-ui";
import { ResultItem } from "./ResultItem";
import { ResultsDropdownProps } from "./types";
import Translations from "@translate/components/Portfolio/Search/ResultsDropdown";
import { I18nUtil } from "@utils/i18n";
import { EmptyState as CommonEmptyState } from "@/src/components/Empty";

const I18n = I18nUtil.createScoped(Translations);

const LoadingComponent = (
  <div className="flex flex-col gap-1 py-1">
    {Array.from({ length: 3 }).map((_, idx) => (
      <div
        key={idx}
        className="flex items-center h-10 gap-2 px-2 py-2 rounded-1.5"
      >
        <div className="w-6 h-6 rounded-full bg-background_white_overlay10 animate-pulse" />
        <div className="flex-1 h-5 min-w-0 w-32 bg-background_white_overlay5 rounded animate-pulse" />
      </div>
    ))}
  </div>
);

export const ResultsDropdown: React.FC<ResultsDropdownProps> = ({
  results,
  loading = false,
  className,
  onSelect,
  hasMore = false,
  onLoadMore,
}) => {
  return (
    <div
      className={cn(
        "absolute mt-2 right-0 w-60 md:bg-background_solid_tertiary bg-transparent border border-border_white_transparent10 rounded-2 p-2 z-10 shadow-[0_8px_24px_rgba(0,0,0,0.24)] z-20",
        className,
      )}
    >
      <div
        className={cn(
          "overflow-y-auto no-scrollbar",
          "md:max-h-[400px] md:min-h-[220px]",
          "max-h-[60vh] min-h-[220px]",
        )}
      >
        {results.length === 0 && !loading ? (
          <div className="h-[220px] flex items-center justify-center">
            <CommonEmptyState
              title={I18n.t("No search results yet")}
              hideDescription
              className="h-full"
              titleClassName="body_s text-content_quaternary"
              hideImage
            />
          </div>
        ) : (
          <VirtualList
            onEndReachedThreshold="50"
            noMoreContainerClassName="h-4"
            hasNextPage={hasMore}
            onEndReached={onLoadMore}
            renderLoading={LoadingComponent}
          >
            <div className="flex flex-col">
              {results.map((item) => (
                <div
                  data-openreplay-label="Search · ResultsDropdown · div"
                  key={item.asset_id}
                  onClick={() => onSelect?.(item)}
                >
                  <ResultItem item={item} />
                </div>
              ))}
            </div>
          </VirtualList>
        )}
      </div>
    </div>
  );
};
